var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNorthMacedonia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c8342d",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4e959",
    d: "M0 19.42v3.33l11.37-7.98a5 5 0 0 1-.52-.86zM10.42 12q.01-.23.04-.45L0 10.5v3l10.46-1.05zM15 7.42q.25.01.5.05L17.4 0h-4.8l1.9 7.47q.25-.04.5-.05m0 .83a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m-15-7v3.33l10.85 5.51q.21-.45.52-.86zM19.58 12q-.01.23-.04.45L30 13.5v-3l-10.46 1.05zm-.95-2.77q.3.4.52.86L30 4.58V1.25zM15 16.58q-.25-.01-.5-.05L12.6 24h4.8l-1.9-7.47q-.25.04-.5.05m15 6.17v-3.33l-10.85-5.51q-.21.45-.52.86z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthMacedonia);
export default __webpack_public_path__ + "static/media/north-macedonia.4bed6e16251c1b21666945aea9d2ba89.svg";
export { ForwardRef as ReactComponent };